import { useState } from "react";
import ModalContato from "../ModalContato";
import { ContainerCard, CardStyle, images } from "../styles";
import { Card } from "antd";

export default function SalinasPremium() {
  const { Meta } = Card;

  return (
    <ContainerCard>
      <Card
        hoverable
        style={CardStyle}
        cover={
          <a href="/empreendimentos/cronogramas/cronograma-salinas-premium.pdf">
            <img
              alt="cronograma"
              src={images.calendario}
              style={{ width: "100%", height: "auto" }} // Ajuste o tamanho da imagem
            />
          </a>
        }
      >
        <Meta
          title="Cronograma"
          description="Última atualização em: 12/09/2024"
        />
      </Card>
    </ContainerCard>
  );
}
